import { isEmpty } from 'lodash'

export const handleUserUpdate = (
  handleOnChange,
  { roles, username, name, email },
  allRoles,
  isUsernameDuplicate,
  isEmailValid,
  isNameInvalid,
  isAuthInvalid,
  modalType
) => {
  return [
    {
      id: 'username_id',
      label: 'Administration:RolesManagement.UserForm.Username',
      placeholder: 'Administration:RolesManagement.UserForm.Username',
      handleChange: (e) =>
        handleOnChange({
          username: e.target.value
        }),
      isDisabled: modalType === 'UpdateUser',
      isInvalid: isUsernameDuplicate,
      invalidText:
        isUsernameDuplicate &&
        'Administration:RolesManagement.UserForm.DuplicateUsername',
      name: 'username',
      value: username,
      type: 'text'
    },
    {
      id: 'name_id',
      label: 'Administration:RolesManagement.UserForm.Name',
      placeholder: 'Administration:RolesManagement.UserForm.Name',
      handleChange: (e) =>
        handleOnChange({
          name: e.target.value
        }),
      isDisabled: false,
      isInvalid: isNameInvalid,
      invalidText:
        isNameInvalid && 'Administration:RolesManagement.RequiredValue',
      name: 'name',
      value: name,
      type: 'text'
    },
    {
      id: 'email_id',
      label: 'Administration:RolesManagement.UserForm.Email',
      placeholder: 'Administration:RolesManagement.UserForm.Email',
      handleChange: (e) =>
        handleOnChange({
          email: e.target.value
        }),
      isDisabled: false,
      isInvalid: isEmailValid,
      invalidText:
        isEmailValid && 'Administration:RolesManagement.UserForm.InvalidEmail',
      name: 'email',
      value: email,
      type: 'text'
    },
    {
      id: 'roles_id',
      labelText: 'Administration:RolesManagement.UserForm.Permission',
      label: 'Administration:RolesManagement.UserForm.Permission',
      placeholder: 'Administration:RolesManagement.UserForm.Permission',
      handleChange: (e) =>
        handleOnChange({
          roles: e.selectedItems
        }),
      isDisabled: false,
      direction: 'bottom',
      isInvalid: isAuthInvalid,
      invalidText:
        isAuthInvalid && 'Administration:RolesManagement.RequiredValue',
      name: 'roles',
      value: roles,
      type: 'multiselect',
      itemsList: allRoles?.map((role) => {
        return {
          label: role.roleName,
          value: role.roleName
        }
      })
    }
  ]
}

export const isUsernameDuplicated = (username, allUsernames) => {
  if (isEmpty(allUsernames)) return false

  return allUsernames.findIndex((name) => name.username === username) >= 0
}
